// The agent's shadow draft for the current suggestion (docs/agent-draft-shadow.md),
// polled briefly because it lands a few seconds after the suggestion: every
// 10 s, up to 6 times, until a draft for this suggestion exists. enabled false
// (a CSR, or an admin in View as Agent) makes no request at all. A new
// suggestionId starts over.
import { useEffect, useState } from 'react'
import { fetchShadowDrafts } from './api.js'
import { shadowDraftFor } from './shadowDraft.js'

export function useShadowDraft(conversationId, suggestionId, enabled = true) {
  const [drafts, setDrafts] = useState(null)

  useEffect(() => {
    let cancelled = false
    let timer = null
    setDrafts(null)
    let tries = 0
    const load = () => {
      fetchShadowDrafts(conversationId)
        .then((d) => {
          if (cancelled) return
          setDrafts(d)
          if (!shadowDraftFor(d, suggestionId) && ++tries < 6) timer = setTimeout(load, 10000)
        })
        .catch(() => { if (!cancelled) setDrafts([]) })
    }
    if (enabled && conversationId && suggestionId) load()
    return () => { cancelled = true; if (timer) clearTimeout(timer) }
  }, [conversationId, suggestionId, enabled])

  return enabled ? shadowDraftFor(drafts, suggestionId) : null
}
